<template>
  <b-modal
    centered
    :visible="show"
    hide-footer
    hide-header
    no-close-on-backdrop
    no-close-on-esc
  >
    <b-container>
      <b-row>
        <b-col>
          <h5 class="text-info">{{ $t("globals.cancell_order") }}:</h5>
        </b-col>
      </b-row>
      <hr />
      <b-row>
        <b-col>
          <label>{{ $t("globals.devices_action") }}</label>
        </b-col>
        <b-col>
          <b-form-select
            style="max-width: 250px"
            v-model="devices_action"
            :options="devices_actions_option"
          />
        </b-col>
      </b-row>
      <b-row class='my-3'>
        <b-col cols='3'>
          <b-form-checkbox v-model="cancell_now">
            {{ $t("globals.now") }}
          </b-form-checkbox>
        </b-col>
        <b-col>
          <b-form-datepicker
            v-model="cancell_at"
            :disabled="cancell_now"
          ></b-form-datepicker>
        </b-col>
      </b-row>
      <hr />
      <b-row>
        <b-col>
          <b-btn size="sm" @click="close" variant="warning">
            {{ $t("globals.cancel") }}
          </b-btn>
        </b-col>
        <b-col>
          <b-btn
            size="sm"
            class="float-right"
            variant="success"
            @click="save"
            :disabled="saveDisabled"
          >
            {{ $t("globals.save") }}
          </b-btn>
        </b-col>
      </b-row>
    </b-container>
  </b-modal>
</template>

<script>
import { mapMutations, mapActions } from "vuex";

export default {
  props: {
    show: Boolean,
    close: Function
  },
  data() {
    return {
      cancell_now: true,
      cancell_at: null,
      devices_action: "devices_stock",
      devices_actions_option: [
        {
          text: "Stock",
          value: "devices_stock"
        },
        {
          text: "Terminate",
          value: "devices_terminate"
        }
      ]
    };
  },
  methods: {
    ...mapActions("axios_mod", ["simpleMutation"]),
    save() {
      let data = {
        query: `
          mutation { 
            res: OrderCancel (
              order_id: ${parseInt(this.$route.params.id)},
              cancell_now: ${this.cancell_now},
              cancell_at: "${this.cancell_at}",
              cancell_type: "${this.devices_action}"
            )
          }
        `
      };

      this.simpleMutation({ data, this_ref: this }).then(() => {
        this.cancell_now = true;
        this.cancell_at = null;
        this.close();
      });
    }
  },
  computed: {
    saveDisabled() {
      return (
        this.cancell_now === false && this.cancell_at === null
      );
    },
  },
  watch: {
    cancell_now(val) {
      if (val) {
        this.cancell_at = null;
      }
    },
  },
};
</script>
